import { render, staticRenderFns } from "./LocationHistoryReportDetails.vue?vue&type=template&id=a408e1ba&scoped=true&"
import script from "./LocationHistoryReportDetails.vue?vue&type=script&lang=js&"
export * from "./LocationHistoryReportDetails.vue?vue&type=script&lang=js&"
import style0 from "./LocationHistoryReportDetails.vue?vue&type=style&index=0&id=a408e1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a408e1ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a408e1ba')) {
      api.createRecord('a408e1ba', component.options)
    } else {
      api.reload('a408e1ba', component.options)
    }
    module.hot.accept("./LocationHistoryReportDetails.vue?vue&type=template&id=a408e1ba&scoped=true&", function () {
      api.rerender('a408e1ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/LocationHistoryReportDetails.vue"
export default component.exports